(function(app) {

    app.constant("_preferredCommunications",
        [
            { ShortName: "Fax", DisplayName: "Fax" },
            { ShortName: "CallBusiness", DisplayName: "Call Business" },
            { ShortName: "CallIsdn", DisplayName: "Call ISDN" },
            { ShortName: "CallHome", DisplayName: "Call Home" },
            { ShortName: "CallCell", DisplayName: "Call Cell" },
            { ShortName: "CallOther", DisplayName: "Call Other" },
            { ShortName: "TextCell", DisplayName: "Text Cell" },
            { ShortName: "EmailBusiness", DisplayName: "Email Business" },
            { ShortName: "EmailPersonal", DisplayName: "Email Personal" },
            { ShortName: "EmailOther", DisplayName: "Email Other" }
        ]);

})(window.app); //jshint ignore:line